import { render, staticRenderFns } from "./GrantAuctionAction.vue?vue&type=template&id=6232700c&scoped=true&"
import script from "./GrantAuctionAction.vue?vue&type=script&lang=ts&"
export * from "./GrantAuctionAction.vue?vue&type=script&lang=ts&"
import style0 from "./GrantAuctionAction.vue?vue&type=style&index=0&id=6232700c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6232700c",
  null
  
)

export default component.exports